// extracted by mini-css-extract-plugin
export default {"mainContainer":"ThankYouPage_mainContainer__W+bCX","content":"ThankYouPage_content__XB5FR","footer":"ThankYouPage_footer__UAQ4t"};